"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toParams = exports.verifyOTPForEIDA = exports.generateOTPForEIDA = exports.getProfileFromEIDA = exports.registerPerson = exports.verifyMobileOTP = exports.generateTokenForRegistration = exports.getProfileFromDNRD = exports.checkEmiratesIdExist = exports.verifyEIDAUpdate = exports.initEIDAUpdate = void 0;
var rest_1 = require("@eres/rest");
var config_1 = __importDefault(require("../config"));
var utils_1 = require("../utils");
var utils_2 = require("./utils");
var core_1 = require("@eres/core");
var utils_3 = require("../requests/utils");
function initEIDAUpdate(eid) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "users/GetTokenForUpdateMobileByEID?" + toParams({ eid: eid }));
}
exports.initEIDAUpdate = initEIDAUpdate;
function verifyEIDAUpdate(eid, token) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "users/UpdateMobileByEID?" + toParams({ eid: eid, otp: token }));
}
exports.verifyEIDAUpdate = verifyEIDAUpdate;
function checkEmiratesIdExist(eid, platform) {
    if (platform === void 0) { platform = "IOS"; }
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "Users/ValidateEmiratesId?" + toParams({ eId: eid, version: platform }))
        .then(function (response) {
        if (response.Code + "" === "0") {
            if (response.Response && Array.isArray(response.Response)) {
                var result = response.Response;
                if (result.length < 1) {
                    return true;
                }
                else {
                    var firstRecord = result[0];
                    if (firstRecord.ErrorNumber === 2) {
                        throw (0, utils_1.MakeSMessageError)(undefined, response, "eid_validation_error");
                    }
                    else {
                        throw (0, utils_1.MakeSMessageError)(firstRecord.ErrorMessage, response);
                    }
                }
            }
        }
        else {
            throw (0, utils_1.MakeSMessageError)(undefined, response, "invalid_emirates_id_information");
        }
        return false;
    });
}
exports.checkEmiratesIdExist = checkEmiratesIdExist;
/**
 * @deprecated The method should not be used,  use eida {@link getProfileFromEIDA}
 */
function getProfileFromDNRD(docType, docNumber, skipMobileValidation) {
    if (skipMobileValidation === void 0) { skipMobileValidation = false; }
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "Tabu/ValidatePersonFromDNRD?" + toParams({ documentType: docType + "", documentNumber: docNumber }))
        .then(function (r) {
        var _a;
        var result = r.Response;
        if (result && result.EmiratesId && !core_1.StringUtil.isEmptyStringOrNull(result.EmiratesId)) {
            if (!skipMobileValidation) {
                var mobile = core_1.StringUtil.normaliseMobileNumber((_a = result === null || result === void 0 ? void 0 : result.Mobile) !== null && _a !== void 0 ? _a : "");
                if (!mobile || mobile.length !== 12) {
                    throw (0, utils_1.MakeSMessageError)(undefined, r, "invalid_mobile");
                }
                else {
                    result.Mobile = mobile;
                }
            }
            r.Response = (0, utils_2.normaliseDNRDModal)(r.Response);
            return r;
        }
        else {
            throw (0, utils_1.MakeSMessageError)("Invalid info for registration", r);
        }
    });
}
exports.getProfileFromDNRD = getProfileFromDNRD;
function generateTokenForRegistration(mobile) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "Tabu/ValidateNewPersonMobile?" + toParams({ mobile: mobile }))
        .then(function (response) {
        if (response.Code + "" === "0") {
            if (response.Response && Array.isArray(response.Response)) {
                var result = response.Response;
                if (result.length < 1) {
                    return true;
                }
                else {
                    var firstRecord = result[0];
                    throw (0, utils_1.MakeSMessageError)(firstRecord.ErrorMessage, response);
                }
            }
        }
        else {
            throw (0, utils_1.MakeSMessageError)("Unable to Generate Token", response);
        }
        return false;
    });
}
exports.generateTokenForRegistration = generateTokenForRegistration;
function verifyMobileOTP(token, mobile) {
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "Users/GetVerifyToken?"
        + toParams({ mobile: mobile, token: token })).then(function (x) { return x.Response; });
}
exports.verifyMobileOTP = verifyMobileOTP;
function registerPerson(request) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "tabu/CreatePerson", request)
        .then(function (resp) {
        return (0, utils_3.ValidateArrayErrorResponse)(resp);
    });
}
exports.registerPerson = registerPerson;
function getProfileFromEIDA(docType, docNumber, skipMobileValidation) {
    if (skipMobileValidation === void 0) { skipMobileValidation = false; }
    return (0, rest_1.httpGet)(config_1.default.tabuAPI().endPoint() + "Tabu/ValidatePersonFromEIDA?" + toParams({ documentType: docType + "", documentNumber: docNumber }))
        .then(function (r) {
        var _a;
        var result = r.Response;
        if (result && result.EmiratesId && !core_1.StringUtil.isEmptyStringOrNull(result.EmiratesId)) {
            if (!skipMobileValidation) {
                var mobile = core_1.StringUtil.normaliseMobileNumber((_a = result === null || result === void 0 ? void 0 : result.Mobile) !== null && _a !== void 0 ? _a : "");
                if (!mobile || mobile.length !== 12) {
                    throw (0, utils_1.MakeSMessageError)(undefined, r, "invalid_mobile");
                }
                else {
                    result.Mobile = mobile;
                }
            }
            r.Response = (0, utils_2.normaliseDNRDModal)(r.Response);
            return r;
        }
        else {
            throw (0, utils_1.MakeSMessageError)("Invalid info for registration", r);
        }
    });
}
exports.getProfileFromEIDA = getProfileFromEIDA;
function generateOTPForEIDA(hash) {
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "Tabu/SendOTP", "\"" + hash + "\"")
        .then(function (response) {
        if (response.Code + "" === "0") {
            if (response.Response === 0) {
                return true;
            }
            if (response.Response && Array.isArray(response.Response)) {
                var result = response.Response;
                if (result.length < 1) {
                    return true;
                }
                else {
                    var firstRecord = result[0];
                    throw (0, utils_1.MakeSMessageError)(firstRecord.ErrorMessage, response);
                }
            }
        }
        else {
            throw (0, utils_1.MakeSMessageError)("Unable to Generate Token", response);
        }
        return false;
    });
}
exports.generateOTPForEIDA = generateOTPForEIDA;
function verifyOTPForEIDA(token, hash, skipMobileValidation) {
    if (skipMobileValidation === void 0) { skipMobileValidation = false; }
    return (0, rest_1.httpPost)(config_1.default.tabuAPI().endPoint() + "Tabu/ValidateOTP?"
        + toParams({ otpCode: token }), "\"" + hash + "\"")
        .then(function (r) {
        var _a;
        var result = r.Response;
        if (result && result.EmiratesId && !core_1.StringUtil.isEmptyStringOrNull(result.EmiratesId)) {
            if (!skipMobileValidation) {
                var mobile = core_1.StringUtil.normaliseMobileNumber((_a = result === null || result === void 0 ? void 0 : result.Mobile) !== null && _a !== void 0 ? _a : "");
                if (!mobile || mobile.length !== 12) {
                    throw (0, utils_1.MakeSMessageError)(undefined, r, "invalid_mobile");
                }
                else {
                    result.Mobile = mobile;
                }
            }
            r.Response = (0, utils_2.normaliseDNRDModal)(r.Response);
            return r;
        }
        else {
            throw (0, utils_1.MakeSMessageError)("Invalid info for registration", r);
        }
    });
}
exports.verifyOTPForEIDA = verifyOTPForEIDA;
function toParams(data) {
    var keys = Object.keys(data);
    var kvs = [];
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var v = data[key];
        if (v == undefined) {
            kvs.push(key + "=");
        }
        else {
            v = encodeURIComponent(v.toString());
            kvs.push(key + "=" + v);
        }
    }
    return kvs.join("&");
}
exports.toParams = toParams;
